import * as colorsConfig from '@/config/colorPallets';
export const colorPallets = [...colorsConfig.popular, ...colorsConfig.monochromatic];